module.exports = __webpack_public_path__ + "static/media/npc-seal-july2025.2ad5bf31.png";